<script>
// This had to be a render function component because there is no way to
// iterate through child slots in reguler single file components.
// The idea is that you can insert your own custom stepper component, and then
// add the sections to be stepped through and the rest is taken care of automatically.
//
export default {

  name: 'MultiStageForm',
  render (h) {
    const currentStep = this.$attrs['current-step']
    const [stepper] = this.$scopedSlots.stepper()
    const items = this.$slots.default

    // Create an array of all the section titles
    const titles = items.map(item => item.data.attrs.title)

    // Use scoped slot to communicate each step's title to the
    // parent component
    stepper.componentOptions.propsData.steps = titles

    // Count the number of steps and emit the result to the parent component
    this.$emit('stepsCounted', titles.length - 1)

    // Wrap the steps in a div with 'multi-stage' class name, along with
    // a title header for each step, and return.
    return h('div', [
      stepper,
      h('div', { class: 'multi-stage' }, [
        items[currentStep].data.attrs.title
          ? h('h2', { class: 'is-size-2' }, items[currentStep].data.attrs.title)
          : null,
        ...items.map((item, index) => {
          // prefer to hide the steps rather than destroy them so we don't have to
          // rerender images etc.
          if (index !== currentStep) {
            item.data.attrs.class = 'is-hidden'
          }
          return item
        })
      ])
    ])
  }
}
</script>
<style lang="scss">
  .multi-stage {

    h1, h2, h3 {
      padding: 10px 0;
      text-align: center;
      background-color: var(--primary-color) !important;
      margin-bottom: 15px;
    }
  }
</style>
